import { DataUrl } from '@barthauer/abc/core';
import { AbcMediaGalleryComponent } from '@barthauer/abc/ui-components';

export enum GalleryImageType {
  Regular = 1,
  AddNewPlaceholder,
}

export class GalleryImage {
  type: GalleryImageType;
  imageSrc: string;
  sourceDocument: MediaDocument;

  constructor() {
    this.type = GalleryImageType.Regular;
  }
}

export class MediaDocument {
  private _previewImageDataUrl: DataUrl;
  private _downloadable: boolean;
  designation: string;
  file: File;

  get previewImageDataUrl(): DataUrl {
    if (!this._previewImageDataUrl) {
      this._previewImageDataUrl = DataUrl.fromString(AbcMediaGalleryComponent.drawTextImage(this.designation));
    }
    return this._previewImageDataUrl;
  }

  set previewImageDataUrl(dataUrl: DataUrl) {
    this._previewImageDataUrl = dataUrl;
  }
  onDownloadButtonClick?: () => Promise<DataUrl>;

  get downloadable(): boolean {
    return this._downloadable && this.onDownloadButtonClick !== undefined;
  }
  set downloadable(downloadable: boolean) {
    this._downloadable = downloadable;
  }

  constructor(init?: Partial<MediaDocument>) {
    Object.assign(this, init);
  }
}

export class SelectedMedia {
  file: File;
  dataUrl: DataUrl;
}

export class DataChangedEventArgs {
  documents: MediaDocument[];
  type: DataChangedType;

  constructor(init?: Partial<DataChangedEventArgs>) {
    Object.assign(this, init);
  }
}

export enum DataChangedType {
  Added = 1,
}
